// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Uv-z","tooltipWrapper":"Vv-z","icon":"Wv-z","tooltip":"Xv-z","content":"Yv-z"};